import { Stack, keyframes, useMediaQuery, useTheme } from '@mui/material';
import { IBurgerMenuItem } from 'API/Home/burgerMenuItems';
import { useAppSelector } from 'Hooks';
import { BurgerMenuAccordion } from '../BurgerMenuAccordion';
import { User } from './User';
import { PersonalDetailsAndUpdates } from './PersonalDetailsAndUpdates';
import { HomePageTab } from './HomePageTab';
import { burgerMenuItemsPersonalDetailsAndUpdatesSlicer } from 'Config';
import { ReduceMenuButton } from './ReduceMenuButton';
import { useMemo, useState } from 'react';
import { useIsLawyer } from 'Hooks/useIsLawyer';

interface IExpandedBurgerMenuView {
  closeMenu?: Function;
  expandedMenuItem?: IBurgerMenuItem | null;
  lawyersName: string;
}

export const ExpandedBurgerMenuView = ({
  closeMenu,
  expandedMenuItem,
  lawyersName,
}: IExpandedBurgerMenuView) => {
  const burgerMenuItems = useAppSelector(
    ({ menuItems: { menuItems } }) => menuItems
  );
  const [expandedAccordionIndex, setExpandedAccordionIndex] =
    useState<number>(-1);

  const theme = useTheme();
  const isScreenXl = useMediaQuery(theme.breakpoints.up('xl'));

  const isLawyer = useIsLawyer();

  const memoizedBurgerMenuItems = useMemo(() => {
    const menuItems = [...burgerMenuItems].slice(
      isLawyer ? 0 : burgerMenuItemsPersonalDetailsAndUpdatesSlicer
    );

    return menuItems.map((burgerItem: IBurgerMenuItem, index: number) => {
      const isMenuCategoryExpanded =
        expandedAccordionIndex === index ||
        expandedMenuItem?.id === burgerItem.id;

      return (
        <BurgerMenuAccordion
          key={index}
          burgerItem={burgerItem}
          accordionIndex={index}
          isExpanded={isMenuCategoryExpanded}
          setExpandedAccordionIndex={setExpandedAccordionIndex}
          closeMenu={closeMenu}
          aria-expanded={
            burgerItem.subItems && burgerItem.subItems.length > 0
              ? isMenuCategoryExpanded
              : undefined
          }
        />
      );
    });
  }, [burgerMenuItems, expandedAccordionIndex, closeMenu, expandedMenuItem]);

  const closeAccordionTabs = () => setExpandedAccordionIndex(-1);

  const slideIn = keyframes`
    from{
      transform: translateX(-100%);
      opacity: 0;
    }
    to{
      transform: translateX(0);
      opacity: 1;
    }
  `;

  return (
    <Stack
      gap='24px'
      paddingTop='24px'
      sx={{
        animation: `${slideIn} .25s ease-in-out`,
      }}
      aria-expanded={isScreenXl ? undefined : true}
    >
      {!isScreenXl && <ReduceMenuButton closeMenu={closeMenu} />}
      <Stack gap='16px'>
        <User lawyersName={lawyersName} />
        {!isLawyer && (
          <PersonalDetailsAndUpdates
            closeAccordionTabs={() => closeAccordionTabs()}
            closeMenu={closeMenu}
          />
        )}
      </Stack>
      <Stack component={'ul'} sx={{ padding: '0', margin: 0 }}>
        <HomePageTab closeAccordionTabs={() => closeAccordionTabs()} />
        {memoizedBurgerMenuItems}
      </Stack>
    </Stack>
  );
};
